import { useAudioVideo } from 'amazon-chime-sdk-component-library-react';
import { useEffect, useState } from 'react';
export function useAttendeeAudioStatus(attendeeId) {
    const audioVideo = useAudioVideo();
    const [volume, setVolume] = useState(1);
    const [muted, setMuted] = useState(false);
    const [signalStrength, setSignalStrength] = useState(1);
    useEffect(() => {
        if (!audioVideo || !attendeeId) {
            return;
        }
        const callback = (_attendeeId, volume, muted, signalStrength) => {
            if (volume !== null) {
                setVolume(volume);
            }
            if (muted !== null) {
                setMuted(muted);
            }
            if (signalStrength !== null) {
                setSignalStrength(signalStrength);
            }
        };
        audioVideo.realtimeSubscribeToVolumeIndicator(attendeeId, callback);
        return () => {
            audioVideo.realtimeUnsubscribeFromVolumeIndicator(attendeeId, callback);
        };
    }, [audioVideo, attendeeId]);
    return {
        volume,
        muted,
        signalStrength,
    };
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlQXR0ZW5kZWVBdWRpb1N0YXR1cy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9ob29rcy91c2VBdHRlbmRlZUF1ZGlvU3RhdHVzL3VzZUF0dGVuZGVlQXVkaW9TdGF0dXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLGFBQWEsRUFBRSxNQUFNLDBDQUEwQyxDQUFDO0FBQ3pFLE9BQU8sRUFBRSxTQUFTLEVBQUUsUUFBUSxFQUFFLE1BQU0sT0FBTyxDQUFDO0FBRTVDLE1BQU0sVUFBVSxzQkFBc0IsQ0FBQyxVQUFtQjtJQUN4RCxNQUFNLFVBQVUsR0FBRyxhQUFhLEVBQUUsQ0FBQztJQUNuQyxNQUFNLENBQUMsTUFBTSxFQUFFLFNBQVMsQ0FBQyxHQUFHLFFBQVEsQ0FBQyxDQUFDLENBQUMsQ0FBQztJQUN4QyxNQUFNLENBQUMsS0FBSyxFQUFFLFFBQVEsQ0FBQyxHQUFHLFFBQVEsQ0FBQyxLQUFLLENBQUMsQ0FBQztJQUMxQyxNQUFNLENBQUMsY0FBYyxFQUFFLGlCQUFpQixDQUFDLEdBQUcsUUFBUSxDQUFDLENBQUMsQ0FBQyxDQUFDO0lBRXhELFNBQVMsQ0FBQyxHQUFHLEVBQUU7UUFDYixJQUFJLENBQUMsVUFBVSxJQUFJLENBQUMsVUFBVSxFQUFFLENBQUM7WUFDL0IsT0FBTztRQUNULENBQUM7UUFFRCxNQUFNLFFBQVEsR0FBRyxDQUNmLFdBQW1CLEVBQ25CLE1BQXFCLEVBQ3JCLEtBQXFCLEVBQ3JCLGNBQTZCLEVBQ3ZCLEVBQUU7WUFDUixJQUFJLE1BQU0sS0FBSyxJQUFJLEVBQUUsQ0FBQztnQkFDcEIsU0FBUyxDQUFDLE1BQU0sQ0FBQyxDQUFDO1lBQ3BCLENBQUM7WUFDRCxJQUFJLEtBQUssS0FBSyxJQUFJLEVBQUUsQ0FBQztnQkFDbkIsUUFBUSxDQUFDLEtBQUssQ0FBQyxDQUFDO1lBQ2xCLENBQUM7WUFDRCxJQUFJLGNBQWMsS0FBSyxJQUFJLEVBQUUsQ0FBQztnQkFDNUIsaUJBQWlCLENBQUMsY0FBYyxDQUFDLENBQUM7WUFDcEMsQ0FBQztRQUNILENBQUMsQ0FBQztRQUNGLFVBQVUsQ0FBQyxrQ0FBa0MsQ0FBQyxVQUFVLEVBQUUsUUFBUSxDQUFDLENBQUM7UUFFcEUsT0FBTyxHQUFHLEVBQUU7WUFDVixVQUFVLENBQUMsc0NBQXNDLENBQUMsVUFBVSxFQUFFLFFBQVEsQ0FBQyxDQUFDO1FBQzFFLENBQUMsQ0FBQztJQUNKLENBQUMsRUFBRSxDQUFDLFVBQVUsRUFBRSxVQUFVLENBQUMsQ0FBQyxDQUFDO0lBRTdCLE9BQU87UUFDTCxNQUFNO1FBQ04sS0FBSztRQUNMLGNBQWM7S0FDZixDQUFDO0FBQ0osQ0FBQyJ9